import React from 'react'
import { useAppDispatch } from '../../../../../hooks/redux'

import FieldModal from '..'

import { updateCustomFields } from '../../../../../slices/customFields'
import { AddSuccessAlert } from '@SonarCX/slices/alert'

type EditFieldModalProps = {
  field: APICustomField
  onClose: () => void
}

const EditFieldModal: React.FC<EditFieldModalProps> = ({
  field,
  onClose,
  ...props
}) => {
  const dispatch = useAppDispatch()

  const handleSave = React.useCallback(
    (field: APICustomField) => {
      dispatch(
        updateCustomFields([field], () => {
          dispatch(AddSuccessAlert('Changes saved'))
          onClose()
        })
      )
    },
    [dispatch, onClose]
  )

  return (
    <FieldModal
      editing
      field={field}
      onClose={onClose}
      onSave={handleSave}
      {...props}
    />
  )
}

export default EditFieldModal
